/* eslint-disable */
import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { register, updateUser } from '../../actions/user';

import { Tooltip } from 'react-tippy';
import CheckoutForm from '../../components/CheckoutForm';
import ContentContainer from '../../components/ContentContainer';
import ErrorContainer from '../../components/ErrorContainer';
import HorizontalRule from '../../components/HorizontalRule';
import OrderSummary from '../../components/OrderSummary';
import SimpleSelect from '../../components/SimpleSelect';
import TextField from '../../components/TextField';

const POWERED_BY_STRIPE = require('./stripe.png');

const civilDefenseLogo = require('./CivilDefense.png');
const goldCardLogo = require('./SuperGold.png');
const TOOLTIP_ASSET = require('./tooltip.svg');

const PRICE = 49.99;
const PROMO_PRICE = 30.0;
const DONATION_PRICE = 1.0;

class JoinPayment extends Component {
  constructor(props) {
    super(props);

    this.continue = this.continue.bind(this);
    this.setValue = this.updateTextField.bind(this);
    this.stickySideHandler = this.stickySideHandler.bind(this);

    const userCity = props.appdata.city.find(city => city.id === parseInt(props.user.city, 10));

    this.state = {
      selected: 'owner',
      active: false,
      completed: false,
      stickySide: false,
      billing_first_name: props.user.billing_first_name
        ? props.user.billing_first_name
        : props.user.first_name,
      billing_last_name: props.user.billing_last_name
        ? props.user.billing_last_name
        : props.user.last_name,
      billing_email: props.user.billing_email ? props.user.billing_email : props.user.email,
      billing_city: userCity ? userCity.title : null,
      billing_post_code: props.user.billing_post_code ? props.user.billing_post_code : null,
      billing_address_1: props.user.billing_address_1 ? props.user.billing_address_1 : null,
      billing_address_2: props.user.billing_address_2 ? props.user.billing_address_2 : null,
      billing_country: 'New Zealand',
      billing_charity: props.user.billing_charity ? props.user.billing_charity : null,
      suburb: props.user.suburb,

      billing_cc_number: null,
      billing_cc_expiry: null,
      billing_cc_cvv: null,

      last4: null,
      stripeToken: null,
      stripeCard: null,

      errors: {
        billing_first_name: false,
        billing_last_name: false,
        billing_email: false,
        billing_city: false,
        billing_post_code: false,
        billing_address_1: false,
        billing_address_2: false,
        billing_country: false,
        billing_charity: false,
        billing_cc_number: false,
        billing_cc_expiry: false,
        billing_cc_cvv: false,
      },
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState(
        {
          active: true,
        },
        () => {
          window.addEventListener('scroll', this.stickySideHandler);
        },
      );
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.stickySideHandler);
  }

  stickySideHandler() {
    if (this.side && this.stickySide) {
      if (window.pageYOffset >= this.side.offsetTop + 70 && !this.state.stickySide) {
        this.setState({
          stickySide: true,
        });
      } else if (window.pageYOffset < this.side.offsetTop + 70 && this.state.stickySide) {
        this.setState({
          stickySide: false,
        });
      }

      if (
        window.pageYOffset - (this.side.offsetTop + 70) <=
        this.side.offsetHeight - this.stickySide.offsetHeight
      ) {
        this.offset = window.pageYOffset - (this.side.offsetTop + 70);
        this.stickySide.style.transform = `translateY(${this.offset > 0 ? this.offset : 0}px)`;
      }
    }
  }

  // Validate the form
  validateForm() {
    const errors = {};

    if (!this.state.billing_first_name || !this.state.billing_first_name.length) {
      errors.billing_first_name = 'Please complete this field';
    } else {
      errors.billing_first_name = null;
    }

    if (!this.state.billing_last_name || !this.state.billing_last_name.length) {
      errors.billing_last_name = 'Please complete this field';
    } else {
      errors.billing_last_name = null;
    }

    if (!this.state.billing_email || !this.state.billing_email.length) {
      errors.billing_email = 'Please complete this field';
    } else {
      errors.billing_email = null;
    }

    if (!this.state.billing_address_1 || !this.state.billing_address_1.length) {
      errors.billing_address_1 = 'Please complete this field';
    } else {
      errors.billing_address_1 = null;
    }

    if (!this.state.billing_city || !this.state.billing_city.length) {
      errors.billing_city = 'Please select a city';
    } else {
      errors.billing_city = null;
    }

    if (!this.state.billing_post_code || !this.state.billing_post_code.length) {
      errors.billing_post_code = 'Please complete this field';
    } else {
      errors.billing_post_code = null;
    }

    if (!this.state.billing_email || !this.state.billing_email.length) {
      errors.billing_email = 'Please complete this field';
    } else {
      errors.billing_email = null;
    }

    if (!this.state.billing_country || !this.state.billing_country.length) {
      errors.billing_country = 'Please complete this field';
    } else {
      errors.billing_country = null;
    }

    if (!this.state.billing_charity) {
      errors.billing_charity = `Please choose the local or favourite dog charity you'd like to support. Your favourite dog charity not here? Please email us.`;
    } else {
      errors.billing_charity = null;
    }

    let formErrors = false;

    for (const key in errors) {
      //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      this.setState({
        errors,
        hasError: true,
      });

      return false;
    }

    this.setState({
      errors,
      hasError: false,
    });

    return true;
  }

  continue(history) {
    if (this.validateForm()) {
      this.props
        .dispatch(
          updateAppState({
            loading: true,
          }),
        )
        .then(() =>
          this.CheckoutForm.verifyCard().then(response => {
            const paymentFields = {
              billing_first_name: this.state.billing_first_name,
              billing_last_name: this.state.billing_last_name,
              billing_email: this.state.billing_email,
              billing_address_1: this.state.billing_address_1,
              billing_address_2: this.state.billing_address_2,
              billing_city: this.state.billing_city,
              billing_post_code: this.state.billing_post_code,
              billing_country: this.state.billing_country,
              billing_charity: this.state.billing_charity,
              stripeToken: this.state.stripeToken,
              stripeCard: this.state.stripeCard,
              last4: this.state.last4,
              payment: true,
            };

            this.props.dispatch(updateUser(paymentFields)).then(
              () => {
                const registrationFields = Object.assign({}, this.props.user, paymentFields);

                this.props.dispatch(register(registrationFields)).then(
                  response => {
                    if (response.transaction.status === 'failed') {
                      this.setState({
                        errors: Object.assign({}, this.state.errors, {
                          card: 'A problem occurred with this card.' + 'Please try another card.',
                        }),
                        hasError: true,
                      });

                      this.props.dispatch(
                        updateAppState({
                          loading: false,
                        }),
                      );
                    } else {
                      this.setState(
                        {
                          completed: true,
                        },
                        () => {
                          setTimeout(() => {
                            // Successful payment - track ecommerce data if there is a transaction attached
                            if (
                              response.transaction &&
                              response.transaction.id &&
                              response.transaction.amount
                            ) {
                              this.props.ga.plugin.execute('ecommerce', 'addTransaction', {
                                id: response.transaction.id,
                                name: `Annual Subscription Year 1`,
                                category: this.props.user.subscription,
                                price: response.transaction.amount,
                                quantity: '1',
                              });
                              this.props.ga.plugin.execute('ecommerce', 'send');
                              this.props.ga.plugin.execute('ecommerce', 'clear');
                            }

                            // Redirect user
                            this.props.dispatch(
                              updateAppState({
                                loading: false,
                              }),
                            );
                            history.push('/join/verify');
                          }, 500);
                        },
                      );
                    }
                  },
                  err => {
                    this.props.dispatch(
                      updateAppState({
                        loading: false,
                      }),
                    );

                    if (err.data.error === 'email_exists') {
                      this.props.dispatch(
                        updateUser({
                          facebook_token: null,
                          fb_id: null,
                        }),
                      );

                      setTimeout(() => {
                        history.push({
                          pathname: '/join/details',
                          state: {
                            error: 'email_exists',
                            message: `The email ${this.props.user.email} already has an account.`,
                            value: this.props.user.email,
                          },
                        });
                      }, 100);
                    } else if (err.data.error === 'incomplete_payment_details') {
                      this.setState({
                        errors: Object.assign({}, this.state.errors, {
                          card:
                            'A problem occured with this card, and you were not charged. ' +
                            'Please try another card.',
                        }),
                        hasError: true,
                      });
                    }
                  },
                );
              },
              err => {
                this.props.dispatch(
                  updateAppState({
                    loading: false,
                  }),
                );
              },
            );
          }),
        );
    }

    return false;
  }

  handleCardToken(response) {
    return new Promise((resolve, reject) => {
      if (response.error) {
        this.setState({
          errors: Object.assign({}, this.state.errors, {
            card:
              'A problem occured with this card, and you were not charged. ' +
              'Please try another card.',
          }),
          hasError: true,
        });

        this.props.dispatch(
          updateAppState({
            loading: false,
          }),
        );

        reject(response);
      } else if (response.token) {
        this.setState({
          stripeToken: response.token.id,
          stripeCard: response.token.card.id,
          last4: response.token.card.last4,
        });

        resolve(response);
      }
    });
  }

  clearCardError() {
    this.setState({
      errors: Object.assign({}, this.state.errors, {
        card: false,
      }),
    });

    if (this.state.hasError) {
      // Attempt to revalidate
      this.validateForm();
    }
  }

  updateTextField(key, value) {
    this.setState({
      [key]: value,
    });

    setTimeout(() => {
      if (this.state.errors[key]) {
        // If there is an error against this field, attempt to revalidate
        this.validateForm();
      }
    }, 10);
  }

  renderCheckoutButton() {
    let Checkout;

    if (this.state.hasError) {
      Checkout = (
        <button
          disabled
          className={css(styles.continue, styles.continue_disabled)}
          onClick={() => {
            this.continue(this.props.history);
          }}
        >
          Checkout
        </button>
      );
    } else {
      Checkout = (
        <button
          className={css(styles.continue)}
          onClick={() => {
            this.continue(this.props.history);
          }}
        >
          Checkout
        </button>
      );
    }

    return Checkout;
  }

  render() {
    return (
      <div>
        <div
          className={css(
            styles.container,
            this.state.active ? styles.container_active : null,
            this.state.completed ? styles.container_completed : null,
          )}
        >
          <ContentContainer>
            <h1 className={css(styles.heading)}>Payment</h1>
            <div className={css(styles.main)}>
              <div className={css(styles.form)}>
                <h2 className={css(styles.sub_heading)}>Personal Details</h2>
                <TextField
                  id="billing_first_name"
                  name="billing_first_name"
                  label="First Name"
                  value={this.state.billing_first_name}
                  handler={this.setValue}
                  error={this.state.errors.billing_first_name}
                />
                <TextField
                  id="billing_last_name"
                  name="billing_last_name"
                  label="Last Name"
                  value={this.state.billing_last_name}
                  handler={this.setValue}
                  error={this.state.errors.billing_last_name}
                />
                <TextField
                  id="billing_email"
                  name="billing_email"
                  label="Email address (for receipt)"
                  email
                  fullWidth
                  value={this.state.billing_email}
                  handler={this.setValue}
                  error={this.state.errors.billing_email}
                />
                <TextField
                  id="billing_address_1"
                  name="billing_address_1"
                  label="Physical Address Line 1"
                  value={this.state.billing_address_1}
                  handler={this.setValue}
                  error={this.state.errors.billing_address_1}
                />
                <TextField
                  id="billing_address_2"
                  name="billing_address_2"
                  label="Physical Address Line 2"
                  value={this.state.billing_address_2}
                  handler={this.setValue}
                />
                <TextField
                  id="billing_city"
                  name="billing_city"
                  label="City"
                  value={this.state.billing_city}
                  handler={this.setValue}
                  error={this.state.errors.billing_city}
                />
                <TextField
                  id="billing_post_code"
                  name="billing_post_code"
                  label="Postcode"
                  value={this.state.billing_post_code}
                  handler={this.setValue}
                  error={this.state.errors.billing_post_code}
                />
                <TextField
                  id="billing_country"
                  name="billing_country"
                  label="Country"
                  value="New Zealand"
                  readOnly={1}
                  handler={this.setValue}
                  error={this.state.errors.billing_country}
                />
                <HorizontalRule />
                <h2 className={css(styles.sub_heading)}>Select your charity</h2>
                <p className={css(styles.paragraph)}>
                  ${DONATION_PRICE.toFixed(2)} of your membership fee will go directly to one of
                  these dog charities.
                  <br />
                  Please choose the dog charity you'd like to support.
                </p>
                <SimpleSelect
                  id="billing_charity"
                  name="billing_charity"
                  options={this.props.appdata.charity.map(charity => ({
                    value: charity.id,
                    label: charity.title,
                  }))}
                  label="Charity"
                  value={this.state.billing_charity}
                  error={this.state.errors.billing_charity}
                  handler={this.setValue}
                />
                <HorizontalRule />
                <h2 className={css(styles.sub_heading)}>Payment</h2>
                <div className={css(styles.creditcard_container)}>
                  <div className={css(styles.creditcard)}>
                    <Elements>
                      <CheckoutForm
                        cardChangedHandler={this.clearCardError.bind(this)}
                        onRef={ref => (this.CheckoutForm = ref)}
                        handler={this.handleCardToken.bind(this)}
                        first_name={this.state.billing_first_name}
                        last_name={this.state.billing_last_name}
                      />
                    </Elements>
                    {this.state.errors.card ? (
                      <ErrorContainer message={this.state.errors.card} />
                    ) : null}
                  </div>
                  <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">
                    <img
                      alt="Payment is secured by Stripe"
                      src={POWERED_BY_STRIPE}
                      className={css(styles.powered_by_stripe)}
                    />
                  </a>
                </div>
                <HorizontalRule />
                <p className={css(styles.paragraph)}>
                  <br />
                  {`Your investment in letting us find a dog the companionship they need,
                  is priceless. Our promise to you, is that our service will bring joy and
                  value well beyond this annual investment. In a dog eat dog world, take
                  sanctuary with us. `}
                </p>
              </div>
              <div
                className={css(styles.side)}
                ref={side => {
                  this.side = side;
                }}
              >
                <div
                  className={css(this.state.stickySide ? styles.side_sticky : null)}
                  ref={stickySide => {
                    this.stickySide = stickySide;
                  }}
                >
                  <OrderSummary
                    type={this.props.user.subscription}
                    membership="Full"
                    price={PRICE}
                    promoPrice={PROMO_PRICE}
                    donationPrice={DONATION_PRICE}
                    promoTitle="#COLLECTIVEGIVING"
                    promoText={
                      <span>
                        One year subscription for $30.00 <br />
                        100% Pooch Pleasure Guarantee: No connections in your first year? Get your
                        second year FREE!
                      </span>
                    }
                    hasError={this.state.hasError}
                    checkout={this.renderCheckoutButton()}
                  />
                  {/*<TestimonialCard
                    photo="/images/spud.png"
                    name="Spud"
                    label="Borrower"
                    location="Auckland"
                    testimonial="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  />*/}
                  <div className={css(styles.freeMembershipNote)}>
                    <div style={{ display: 'flex' }}>
                      <img
                        src={goldCardLogo}
                        alt="Gold Card"
                        className={css(styles.freeMembershipNoteLogos)}
                      />
                      <Tooltip
                        style={{ alignSelf: 'center', marginLeft: 10 }}
                        arrow
                        html={
                          <div className={css(styles.actions_tooltip)}>
                            SuperGold Card Holders go FREE! Please do not proceed through payment,
                            instead email us at support@thedogsharecollective.com.
                          </div>
                        }
                      >
                        <Isvg
                          cacheGetRequests
                          src={TOOLTIP_ASSET}
                          className={css(styles.actions_tooltip_trigger)}
                        />
                      </Tooltip>
                    </div>
                    <div style={{ display: 'flex' }}>
                      <img
                        src={civilDefenseLogo}
                        alt="Civil Defense"
                        className={css(styles.freeMembershipNoteLogos)}
                      />
                      <Tooltip
                        style={{ alignSelf: 'center', marginLeft: 10 }}
                        arrow
                        html={
                          <div className={css(styles.actions_tooltip)}>
                            In a Civil Defence Emergency? You go FREE! Please do not proceed through
                            payment, instead email us at support@thedogsharecollective.com.
                          </div>
                        }
                      >
                        <Isvg
                          cacheGetRequests
                          src={TOOLTIP_ASSET}
                          className={css(styles.actions_tooltip_trigger)}
                        />
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ContentContainer>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  freeMembershipNote: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 60,
  },
  freeMembershipNoteLogos: {
    width: 100,
    height: '100%',
  },
  actions_tooltip: {
    padding: 5,
    fontSize: 14,
    marginLeft: 10,
    alignSelf: 'center',
    fontFamily: Theme.font_family_primary,
  },
  actions_tooltip_trigger: {
    alignItems: 'center',
    cursor: 'pointer',
  },
  creditcard_container: {
    position: 'relative',
    display: 'flex',
    width: '100%',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  creditcard: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    width: '50%',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  input_sm: {
    ':not(.a) > input': {
      width: '70%',

      [Theme.mobile_query]: {
        width: '100%',
      },
    },

    [Theme.mobile_query]: {
      width: '50%',
    },
  },
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',
    transform: 'translateX(100vw)',

    [Theme.mobile_query]: {
      padding: '50px 0',
    },
  },
  container_active: {
    transform: 'translateX(0)',
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',

    [Theme.mobile_query]: {
      flexWrap: 'wrap',
    },
  },
  side: {
    width: 360,
    transform: 'translate3d(0,0,0)',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  heading: {
    marginBottom: 42,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f',
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4,
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    margin: '0 -5px',

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
  continue: {
    width: '100%',
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
  },
  continue_disabled: {
    opacity: 0.5,
    backgroundColor: '#999',
    pointerEvents: 'none',
  },
  powered_by_stripe: {
    position: 'absolute',
    right: 0,
    maxWidth: 223.5,
    maxHeight: 61.5,

    [Theme.mobile_query]: {
      position: 'relative',
      marginTop: 20,
      right: 'auto',
      maxWidth: 112.25,
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
    },
  },
});

JoinPayment.propTypes = {
  appdata: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  ga: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(JoinPayment);



// WEBPACK FOOTER //
// ./src/views/JoinPayment/index.js